export default __webpack_public_path__ + "static/media/profilePicture.cb5bda3c.jpeg";